'use strict';
var trunc = require('../internals/trunc');

/**
 * 将传入的参数转换为整数并返回整数部分
 * @param {any} argument 要转换为整数的参数。
 * @returns {number} 参数的整数部分
 */
module.exports = function(argument) {
  var number = +argument;

  // eslint-disable-next-line no-self-compare
  return number !== number || number === 0 ? 0 : trunc(number);
};
